export default "__VITE_ASSET__DvJPA_5u__";